import * as React from 'react';
import {
  motion,
} from 'framer-motion';

import {
  Lang,
  Breakpoint,
  Colors,

  getColorScheme,
  useDimensions,

  Form,
  TextBlock,
} from '@bluecurrent/web-component-lib';

import handleLocalUrlChange from '../../../functions/handleLocalUrlChange';
import handleHeadingPrioritization from '../../../functions/handleHeadingPrioritization';

import Setup from '../../../config/Setup.config';

import SuccessMessage from './SuccessMessage';

export default function HubSpot(props) {
  const { i18n } = Lang.useTranslation();
  const size = useDimensions();

  const lang = Setup.PSEUDO ? Setup.FALLBACK_LANG : i18n.language;

  const [isLoading, setLoading] = React.useState(true);
  const [successMessage, setSuccessMessage] = React.useState({
    isVisible: false,
    content: '',
  });
  const [id, setId] = React.useState(props.data.id);

  React.useEffect(() => {
    setLoading(false);
  }, []);

  React.useEffect(() => {
    setId(props.data.id);
  }, [lang]);

  return (
    <motion.div
      style={{
        width: '100%',
        height: 'auto',
      }}
      initial={{
        opacity: 0,
      }}
      whileInView={{
        opacity: 1,
      }}
      transition={{
        duration: 0.5,
        ease: 'easeInOut',
        stiffness: 100,
      }}
      viewport={{
        once: true,
      }}
    >
      {
          (
            props.data?.text_block?.title
            || props.data?.text_block?.text
          ) && (
            <TextBlock
              title={{
                content: (!isLoading && props.data.text_block.title !== undefined) && (
                  props.data.text_block.title[lang]
                ),
                portableText: !isLoading && props.data.text_block.title !== undefined,
                fontSize: '2.5em',
                color: props.params.background ? Colors.WHITE : Colors.GREY,
                heading: handleHeadingPrioritization(props.params.index),
              }}
              text={{
                content: (!isLoading && props.data.text_block.text !== undefined) && (
                  props.data.text_block.text[lang]
                ),
                portableText: !isLoading && props.data.text_block.text !== undefined,
                color: props.params.background ? Colors.WHITE : Colors.GREY,
              }}
              align={
                size.width < Breakpoint.sm
                  ? props.data.text_block.align
                  : 'left'
              }
              buttons={
                props.data.text_block.buttons !== undefined
                && props.data.text_block.buttons.map((item) => ({
                  /* eslint-disable no-underscore-dangle */
                  id: item._key,
                  text: item.link.text === 'custom' ? item.link.custom_text[lang] : item.link.text[lang],
                  colorScheme: item.colorscheme,
                  onClick: () => window.open(handleLocalUrlChange(item.link.url), item.link.target),
                }))
              }
            />
          )
        }
      <div
        style={{
          borderRadius: props.data.background ? 10 : 0,
          backgroundColor: props.data.background ? getColorScheme(props.data.background).vibrant : 'transparent',
          padding: size.width < Breakpoint.sm ? 10 : 30,
        }}
      >
        <div
          style={{
            backgroundColor: props.data.background ? Colors.WHITE : 'transparent',
            padding: props.data.background ? 15 : 0,
            borderRadius: props.data.background ? 10 : 0,
          }}
        >
          {
              successMessage.isVisible
                ? (
                  <SuccessMessage
                    onClose={() => {
                      setSuccessMessage({
                        isVisible: false,
                        content: '',
                      });
                    }}
                    content={{
                      text: successMessage.content,
                    }}
                  />
                )
                : (
                  <Form
                    type="HubspotCustom"
                    id={id[lang]}
                    reCaptchaCredential="6Lcc6T0jAAAAAMDZJUZpwKZ46bmsrPWdEU6up_Au"
                    onError={(err, when) => console.log(`Error '${err}' occured at ${when}`)}
                    onSubmit={(message) => {
                      setSuccessMessage({
                        isVisible: true,
                        content: message.toString().replace(/(<([^>]+)>)/ig, ''),
                      });
                    }}
                    getResponse={(response) => {
                      if (response.find((item) => item.name === 'aantal_laadpalen')) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                          event: 'formSubmission',
                          form: [{
                            id: id[lang],
                            aantal_laadpalen: response.find((item) => item.name === 'aantal_laadpalen').value,
                          }],
                        });
                      }
                    }}
                    loading
                    submitButton={{
                      colorScheme: props.data.colorscheme,
                    }}
                  />
                )
            }
        </div>
      </div>
    </motion.div>
  );
}
